/**
 * Copyright © 2026 Indisea Software LLC. All rights reserved.
 *
 * Proprietary and confidential. Licensed, not sold. Use is subject to the
 * license agreement between Indisea Software LLC and the licensee.
 * See LICENSE for full terms.
 *
 * SPDX-License-Identifier: LicenseRef-Indisea-Proprietary
 */

// The brand CDN base URL is provided at build time from AWS Secrets Manager
// (REACT_APP_BRAND_CDN_URL, injected by CI as a Docker build-arg -> .env.local).
// No default is hardcoded here; for local builds set REACT_APP_BRAND_CDN_URL yourself.
export const brandCdn = (process.env.REACT_APP_BRAND_CDN_URL || "").replace(/\/$/, "");

export const navLogoUrl = `${brandCdn}/logos/SVG/Wordmark/White-Wordmark.svg`;

export const faviconUrl = `${brandCdn}/logos/SVG/Logo/faviconV2.jpg`;
